import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ProductSelectionService } from '../../../../../../../core/services/product-selection.service';
import { FuelTypeOption } from '../../../../../../../core/interfaces/funnel.interface';
import { ISummaryData, ProductInformation } from '../../../../../../../core/models/summary-data';
import { SummaryService } from '../../../../../../../core/services/summary.service';
import { CatalogService } from '../../../../../../../core/services/catalog.service';

@Component({
  selector: 'app-refueling',
  standalone: false,
  templateUrl: './refueling.component.html',
  styleUrl: './refueling.component.scss'
})
export class RefuelingComponent {

  @Output() catalogDataCompleted = new EventEmitter<ProductInformation>();

  selectedItem: any;
  selectedItemCards: any;
  fuelTypeOptions: FuelTypeOption[] = [];
  selectedFuelType = 0;
  showResume = false;
  summaryData: ISummaryData = {} as ISummaryData;
  fuelTypeFromSummaryData: number | undefined = 0;
  totalOrderAmount = 0;

  constructor(private router: Router, private productService: ProductSelectionService, private summaryService: SummaryService,
    private catalogDataService: CatalogService
  ) {
    this.selectedItem = this.router.getCurrentNavigation()?.extras.state?.['selectedItem'];
    this.selectedItemCards = this.selectedItem?.product?.relatedCards;
    const stored = this.summaryService.getSummary();
    if (stored) {
      this.summaryData = stored;
    } else {
      const local = localStorage.getItem('summaryData');
      if (local) {
        this.summaryData = JSON.parse(local);
        this.summaryService.setSummary(this.summaryData);
      } else {
        this.summaryData = {
          productInformation: {}
        };
      }
    }

  }

  ngOnInit() {
    const selected = this.productService.getProduct();
    this.selectedItem = selected;
    this.fuelTypeFromSummaryData = this.summaryData.vehicleData?.fuelType;
    if (this.fuelTypeFromSummaryData == 1 || this.fuelTypeFromSummaryData == 5) {
      this.selectFuel('gasolina95');
    }
    if (this.fuelTypeFromSummaryData == 3 || this.fuelTypeFromSummaryData == 5) {
      this.selectFuel('diesel');
    }
    this.selectAmount(10);
    this.totalOrderAmount = this.selectedItem?.CaflerFee ?? 0;
  }

  selectedFuel: string | undefined;
  selectedFuelCode: number | undefined;
  selectedAmount: number | undefined;

  selectFuel(fuel: string): void {
    switch (fuel) {
      case 'gasolina95':
        this.selectedFuelCode = 1;
        this.selectedFuel = 'gasolina95';
        break;
      case 'gasolina98':
        this.selectedFuelCode = 2;
        this.selectedFuel = 'gasolina98';
        break;
      case 'diesel':
        this.selectedFuelCode = 3;
        this.selectedFuel = 'diesel';
        break;
      case 'dieselPremium':
        this.selectedFuelCode = 8;
        this.selectedFuel = 'dieselPremium';
        break;
      default:
        this.selectedFuel = undefined;
        break;
    }
  }

  selectAmount(amount: number): void {
    this.selectedAmount = amount;
  }

  isFormValid(): boolean {
    return this.selectedFuel !== null && this.selectedAmount !== null;
  }

  showForm(): void {
    this.showResume = true;
  }

  submitForm(): void {
    if (this.isFormValid()) {
      const caflerFee = this.selectedItem.product?.CaflerFee ?? 0;
      const price = this.selectedAmount;
      const taxRate = 0.21;
      const subtotal = (price ?? 0) + caflerFee;
      const taxAmount = subtotal * taxRate;
      const total = subtotal + taxAmount;

      this.summaryData = {
        ...this.summaryData,
        productInformation: {
          ZoneId: this.summaryData.productInformation?.ZoneId,
          FinishZoneId: this.summaryData.productInformation?.FinishZoneId,
          icon: this.selectedItem.icon,
          product: this.selectedItem
        },
        serviceConfiguration: {
          fuelType: this.selectedFuelCode,
          monetaryAmount: this.selectedAmount
        },
        TotalOrderAmount: parseFloat(total.toFixed(2)),
        TotalOrderTaxAmount: parseFloat(taxAmount.toFixed(2))
      };
  
      this.summaryService.setSummary(this.summaryData);
  
      this.showResume = true;
      this.catalogDataService.emitProductInfo(this.summaryData);
    }
  }

}
